// utils/statusConfig.js
// Декларативная конфигурация для отображения статусов и действий

export const STATUS_CONFIG = {
  // Конфигурация состояний (state)
  states: {
    'in-kindergarten': {
      label: 'В дитячому закладі',
      badgeClass: 'status-success',
      icon: '🏫'
    },
    'graduated': {
      label: 'Випуск',
      badgeClass: 'status-verified',
      icon: '🎓'
    },
    'transferred': {
      label: 'Переведений',
      badgeClass: 'status-warning',
      icon: '🔄'
    },
    'left': {
      label: 'Вибуття',
      badgeClass: 'status-error',
      icon: '🚪'
    },
    'on-vacation': {
      label: 'У відпустці',
      badgeClass: 'status-info',
      icon: '🏖️'
    },
    'on-sick-leave': {
      label: 'На лікарняному',
      badgeClass: 'status-pending',
      icon: '🏥'
    },
    'out-of-scope':{
      label: 'Дитина вибута',
      badgeClass: 'status-pending',
      icon: '🏥'
    }
  },

  // Конфигурация действий (action)
  actions: {
    'enrollment': {
      label: 'Зачислення',
      description: (data) => `Зачислено до групи "${data.group}"`,
      icon: '📝'
    },
    'transfer-group-curperiod': {
      label: 'Переведення між групами',
      description: (data) => `Переведено до "${data.group}"`,
      icon: '🔄'
    },
    'transfer-group-nextperiod':{
        label: 'Переведення до групи наступного навчального року',
        description: (data) => `Переведено  до "${data.group}"`,
        
    },
    'graduation': {
      label: 'Випуск',
      description: (data) => `Випуск з дитячого закладу`,
      icon: '🎓'
    },
    'dismissal': {
      label: 'Вибуття',
      description: (data) => `Вибуття з дитячого закладу${data.reason ? ` (${data.reason})` : ''}`,
      icon: '🚪'
    }
  },

  // Конфигурация документов
  documents: {
    'removalOrder': {
      label: 'Наказ на вибуття',
      icon: '📄',
      getDocumentId: (status) => status.removalOrder?.orderDoc
    },
    'transferOrder': {
      label: 'Наказ на переведення',
      icon: '📄',
      getDocumentId: (status) => status.detailTransfer?.doc?.orderDoc
    },
    'enrollmentOrder': {
      label: 'Наказ на зачислення',
      icon: '📄',
      getDocumentId: (status) => status.enrollmentOrder?.orderDoc
    }
  }
};

// Вспомогательные функции
export const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('uk-UA');
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleString('uk-UA');
};

// Получение конфигурации для статуса
export const getStatusConfig = (status) => {
  const stateConfig = STATUS_CONFIG.states[status.state] || {
    label: status.state,
    badgeClass: 'status-default',
    icon: '📌'
  };

  const actionConfig = STATUS_CONFIG.actions[status.action] || {
    label: status.action,
    description: () => status.comment || 'Дія виконана',
    icon: '⚡'
  };

  return {
    state: stateConfig,
    action: actionConfig,
    date: formatDateTime(status.date),
    user: getUserInfo(status.actionBy),
    documents: getDocumentsFromStatus(status)
  };
};

// Получение информации о пользователе
const getUserInfo = (actionBy) => {
  if (!actionBy) return 'Система';
  
  if (actionBy.source === 'system') return 'Система';
  if (actionBy.source === 'user' && actionBy.detail) {
    return actionBy.detail.name || 'Користувач';
  }
  
  return 'Заявник';
};

// Получение документов из статуса
const getDocumentsFromStatus = (status) => {
  const documents = [];
  
  Object.keys(STATUS_CONFIG.documents).forEach(docType => {
    const docConfig = STATUS_CONFIG.documents[docType];
    const docId = docConfig.getDocumentId(status);
    
    if (docId) {
      documents.push({
        type: docType,
        label: docConfig.label,
        icon: docConfig.icon,
        id: docId
      });
    }
  });
  
  return documents;
};